import { isTrueDemandInventory } from '../../shared/true-demand-inventory';

import { InventoryOverviewItem } from './inventory-overview';

// it returns [quantity, quantity, quantity] according to given inventory and requested quantity
// to spread consumption from inventories
export const spreadSelectedQuantityOverInventories = (
  selectedQuantity: number,
  availableBulk: number,
  availableInventories: InventoryOverviewItem[],
  skipInventoryCheck = false,
): number[] => {
  // this is the case when we want to remove a basket item,
  // so we "consume" 0 from each inventory (so) remove from each consumption
  if (selectedQuantity === 0) {
    return availableInventories.map(() => 0);
  }

  if (availableBulk - selectedQuantity >= 0) {
    return [];
  }

  const valuesForInventories: number[] = [];

  let remainingQuantity = selectedQuantity - availableBulk;

  for (const inventory of availableInventories) {
    if (remainingQuantity <= 0) {
      valuesForInventories.push(0);
    } else {
      if (
        inventory.maxQuantity === Infinity ||
        skipInventoryCheck ||
        isTrueDemandInventory(inventory.inventoryId)
      ) {
        valuesForInventories.push(remainingQuantity);
        break;
      }

      remainingQuantity -= inventory.maxQuantity ?? 0;

      if (remainingQuantity >= 0) {
        valuesForInventories.push(inventory.maxQuantity ?? 0);
      } else if (remainingQuantity < 0) {
        valuesForInventories.push(inventory.maxQuantity + remainingQuantity);
      }
    }
  }

  return valuesForInventories;
};
